import React from 'react'

const ImportPeople = () => {
  return (
    <div>ImportPeople</div>
  )
}

export default ImportPeople